import { render, staticRenderFns } from "./ManageDiscussionForum.vue?vue&type=template&id=5bef116b&"
import script from "./ManageDiscussionForum.vue?vue&type=script&lang=js&"
export * from "./ManageDiscussionForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports